import React, {useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';
import DoneIcon from '@material-ui/icons/Done';

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData('Cupcake', 305, 3.7, 67, 4.3),
  createData('Donut', 452, 25.0, 51, 4.9),
  createData('Eclair', 262, 16.0, 24, 6.0),
  createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
  createData('Gingerbread', 356, 16.0, 49, 3.9),
  createData('Honeycomb', 408, 3.2, 87, 6.5),
  createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
  createData('Jelly Bean', 375, 0.0, 94, 0.0),
  createData('KitKat', 518, 26.0, 65, 7.0),
  createData('Lollipop', 392, 0.2, 98, 0.0),
  createData('Marshmallow', 318, 0, 81, 2.0),
  createData('Nougat', 360, 19.0, 9, 37.0),
  createData('Oreo', 437, 18.0, 63, 4.0),
];

// function nameColor(rank,handle){
//   return(
//     <span>{}</span>
//   )
// }

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: 'rank', numeric: true, disablePadding: false, label: '#' },
  { id: 'name', numeric: false, disablePadding: false, label: 'Name' },
  { id: 'score', numeric: true, disablePadding: false, label: 'Score' },
  { id: 'penalty', numeric: true, disablePadding: false, label: 'Penalty' },
  { id: 'q1', numeric: true, disablePadding: false, label: 'A' },
  { id: 'q2', numeric: true, disablePadding: false, label: 'B' },
  { id: 'q3', numeric: true, disablePadding: false, label: 'C' },
  { id: 'q4', numeric: true, disablePadding: false, label: 'D' },
  { id: 'q5', numeric: true, disablePadding: false, label: 'E' },
  { id: 'q6', numeric: true, disablePadding: false, label: 'F' },
  { id: 'q7', numeric: true, disablePadding: false, label: 'G' },
];


function EnhancedTableHead(props) {
  console.log(props)
  const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort, contest } = props;
  

  
  // const [qsHeadCells,setQsHeadCells] = useState([]);
  // useEffect(() => {
    
  // },[])
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell,index) => (
          <>
          
            {index < props.contest+4 ? <>{index==0 ? <TableCell className={classes.tableCell}
            style={{width:'1rem'}}
            key={headCell.id}
            align='left'
            sortDirection={orderBy === headCell.id ? order : false}
              ><TableSortLabel style={{fontWeight:'700',fontSize:'1.3rem',paddingLeft:'0.5rem'}}>
              {headCell.label}
            </TableSortLabel></TableCell>: 
            index == 1 ? <TableCell className={classes.tableCell}
            style={{width:'26rem'}}
            key={headCell.id}
            align='left'
            sortDirection={orderBy === headCell.id ? order : false}
              ><TableSortLabel style={{fontWeight:'700',fontSize:'1.3rem',paddingLeft:'0.5rem'}}>
              {headCell.label}
            </TableSortLabel></TableCell>: 
            index > 3 ? <TableCell className={classes.tableCell}
            style={{width:'5rem',paddingRight:'0'}}
            key={headCell.id}
            align='left'
            sortDirection={orderBy === headCell.id ? order : false}
              ><TableSortLabel style={{fontWeight:'700',fontSize:'1.3rem',paddingLeft:'0.5rem'}}>
              {headCell.label}
            </TableSortLabel></TableCell>:<TableCell className={classes.tableCell}
            style={{width:'7rem',paddingRight:'0'}}
            key={headCell.id}
            align='left'
            sortDirection={orderBy === headCell.id ? order : false}
              ><TableSortLabel style={{fontWeight:'700',fontSize:'1.3rem',paddingLeft:'0.5rem'}}>
              {headCell.label}
            </TableSortLabel></TableCell>}</>:<></>}

          </>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  contest: PropTypes.number.isRequired
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      {numSelected > 0 ? (
        <Typography className={classes.title} color="inherit" variant="subtitle1" component="div">
          {numSelected} selected
        </Typography>
      ) : (
        <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
          Standings
        </Typography>
      )}
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 550,
  },
  tableCell:{
    borderLeft:'0px solid #E0E0E0'
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}));

export default function EnhancedTable(props) {
  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);
  const [data,setData] = useState();
  const [show,setShow] = useState(true);
  const [finalDat, setFinalDat] = useState([]);
  const [finalFinalDat1, setFinalFinalDat1] = useState([]);
  const [finalFinalDat2, setFinalFinalDat2] = useState([]);
  const [count,setCount] =useState(0);
  const [officialNo, setOfficialNo] = useState(0);
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    async function fetchData()
    {
      const res=await fetch (`https://api.codedigger.tech/contest/shortCode/${props.contest}/standing`,{
        method:"GET",
        headers:{
          "Content-Type":"application/json",
        }
      });
      res
        .json()
        .then(res => setData(res))
        .then(show => setShow(false));
    }
    fetchData();
  },[])

  function comapareFunc(a, b) {
    const bandA = getScore(a.submissions);
    const bandB = getScore(b.submissions);
    // console.log(bandA);
    // console.log(bandB);
    const myA=getPenalty(a.submissions);
    const myB=getPenalty(b.submissions);
    // const myB=b.penalty;
  
    let comparison = 0;
    if (bandA < bandB) {
      comparison = 1;
    }
    else if(bandA == bandB)
    {
      if (myA < myB) {
      comparison = -1;
      }
      else  {
      comparison = 1;
      }
    }
    else if (bandA > bandB) {
      comparison = -1;
    }
    return comparison;
  }

  useEffect(() => {
      if(!show)
      {
          setFinalDat(data.results.standing.sort(comapareFunc));
          // console.log(finalDat);
      }
  })

  useEffect(() => {
    if(data)
    {
      console.log(data.results.contest[0].showOnlyOfficial===false);
      if(finalDat.length >0 && count==0 && data.results.contest[0].showOnlyOfficial===false)
      {
        // setFinalFinalDat(finalDat.splice());
        // Array.prototype.push.apply(finalFinalDat,finalDat);
        finalDat.map((dat,index) => {
          if(dat.isOfficial === false)
          {
            // console.log(index);
            finalFinalDat1.push(dat);
            // setFinalDat(...finalDat,dat);
          }
          else
          {
            // console.log(dat);
            finalFinalDat2.push(dat);
          }
        })
        console.log(finalFinalDat1)
        console.log(finalFinalDat2)
        setOfficialNo(finalFinalDat2.length);
        finalFinalDat2.push({"partition":true});
        Array.prototype.push.apply(finalFinalDat2, finalFinalDat1);
        console.log(finalFinalDat2);
        setCount(count+1);
      }
      else if(finalDat.length >0 && count==0 && data.results.contest[0].showOnlyOfficial===true)
      {
        // setFinalFinalDat(finalDat.splice());
        // Array.prototype.push.apply(finalFinalDat,finalDat);
        finalDat.map((dat,index) => {
          if(dat.isOfficial === false)
          {
            // console.log(index);
            finalFinalDat1.push(dat);
            // setFinalDat(...finalDat,dat);
          }
          else
          {
            // console.log(dat);
            finalFinalDat2.push(dat);
          }
        })
        console.log(finalFinalDat1)
        console.log(finalFinalDat2)
        setOfficialNo(finalFinalDat2.length);
        // finalFinalDat2.push({"partition":true});
        // Array.prototype.push.apply(finalFinalDat2, finalFinalDat1);
        console.log(finalFinalDat2);
        setCount(count+1);
      }
    }
      // 
  })

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

//   const handleClick = (event, name) => {
//     const selectedIndex = selected.indexOf(name);
//     let newSelected = [];

//     if (selectedIndex === -1) {
//       newSelected = newSelected.concat(selected, name);
//     } else if (selectedIndex === 0) {
//       newSelected = newSelected.concat(selected.slice(1));
//     } else if (selectedIndex === selected.length - 1) {
//       newSelected = newSelected.concat(selected.slice(0, -1));
//     } else if (selectedIndex > 0) {
//       newSelected = newSelected.concat(
//         selected.slice(0, selectedIndex),
//         selected.slice(selectedIndex + 1),
//       );
//     }

//     setSelected(newSelected);
//   };

  const getScore = (submissions) => {
      var score =0;
      submissions.map((subm,index) => {
        if(subm.isSolved)
        {
            score=score+1;
        }
      })
      return score;
  }

  const getPenalty = (submissions) => {
    var pen=0;
      submissions.map((subm,index) => {
        if(subm.isSolved)
        {
            pen=pen+subm.penalty;
        }
      })
      return pen;
  }

  const handleSearchText = (event) => {
    event.preventDefault();
    setSearchText(event.target.value);
  }

  const submitSearchText = (event) => {
    event.preventDefault();
    window.location.href=`/contest/shortCode/${props.contest}/standing/${searchText}`;
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

//   const emptyRows = rowsPerPage - Math.min(rowsPerPage, {show ? 50});
  const emptyRows = show ? rowsPerPage - Math.min(rowsPerPage,50):rowsPerPage - Math.min(rowsPerPage,data.results.standing.length)

  

  if(!show && data.results.contest[0].showOnlyOfficial === false)
  {
  return (
      show && finalFinalDat2.length == 0 ? <><h1>Standings</h1><h1>Loading</h1></>:<><h2>{data.results.contest[0].name}</h2>
      {/* {console.log(data.results.standing)} */}
      <div style={{display:'flex',alignItems:'center'}}>
        <span style={{width:'8rem'}}>Search User</span>
        <form onSubmit={submitSearchText} className={classes.root} noValidate autoComplete="off">
          <TextField value={searchText} onChange={handleSearchText} id="outlined-basic" label="User" variant="outlined" />
          <Button onClick={submitSearchText}><SearchIcon style={{fontSize:'35',paddingBottom:'5px',paddingTop:'3px'}}/></Button>
        </form>
      </div>
      <div className={classes.root}>
      <Paper className={classes.paper}>
        <EnhancedTableToolbar numSelected={selected.length} />
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size='small'
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              order={order}
              orderBy={orderBy}
              rowCount={data.results.standing.length}
              contest={data.results.contest[0].nproblems}
            />
            <TableBody>
              {console.log(page)}
              {console.log(rowsPerPage)}
              {stableSort(finalFinalDat2, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.name);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  

                  if(row.partition)
                  {
                    return(
                      <h2>&nbsp;&nbsp;&nbsp;Practice</h2>
                    )
                  }
                  else
                  {
                    return (
                      <TableRow hover
                        tabIndex={-1}
                        key={row.name}
                      >
                        {console.log(officialNo)}
                        {(page*rowsPerPage) + index > officialNo ? <TableCell className={classes.tableCell} align="left">{((page*rowsPerPage) + index) - officialNo}</TableCell>:
                        <TableCell className={classes.tableCell} align="left">{(page*rowsPerPage) + index+1}</TableCell>}
                        <TableCell className={classes.tableCell} component="th" id={labelId} scope="row" padding="none" style={{fontSize:'1.1rem',fontWeight:'700'}}>
                          {row.user.rank === "newbie" ? <span style={{color:'gray'}}>{row.user.handle}</span>:
                            row.user.rank === "pupil" ? <span style={{color:'green'}}>{row.user.handle}</span>:
                            row.user.rank === "specialist" ? <span style={{color:'cyan'}}>{row.user.handle}</span>:
                            row.user.rank === "expert" ? <span style={{color:'blue'}}>{row.user.handle}</span>:
                            row.user.rank === "candidate master"  ? <span style={{color:'violet'}}>{row.user.handle}</span>:
                            row.user.rank === "international master" || row.user.rank === "master"? <span style={{color:'orange'}}>{row.user.handle}</span>:
                            row.user.rank === "grandmaster" || row.user.rank === "international grandmaster" ? <span style={{color:'red'}}>{row.user.handle}</span>:
                            <span style={{color:'black'}}>{row.user.handle}</span>
                          }
                        </TableCell>
                        <TableCell className={classes.tableCell} align="center">{getScore(row.submissions)}</TableCell>
                        <TableCell className={classes.tableCell} align="center">{getPenalty(row.submissions)}</TableCell>
                        
                        {row.submissions.map((subm,index) => {
                          return(
                            <TableCell className={classes.tableCell} align="left">
                          {row.submissions[index].isSolved ? <><DoneIcon/> <br/> - {row.submissions[index].penalty}</>:<><span>--</span></>}
                        </TableCell>
                          )
                        })}
                        
                      </TableRow>
                    );
                  }
                })}
              {emptyRows > 0 && (
                <TableRow hover style={{ height: (dense ? 33 : 53) * emptyRows }}>
                  <TableCell className={classes.tableCell} colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[50, 75, 100]}
          component="div"
          count={data.results.standing.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
    </div></>
  );
  }
  else
  {
    return (
      show && finalFinalDat2.length == 0 ? <><h1>Standings</h1><h1>Loading</h1></>:<><h2>{data.results.contest[0].name}</h2>
      {/* {console.log(data.results.standing)} */}
      <div className={classes.root}>
      <Paper className={classes.paper}>
        <EnhancedTableToolbar numSelected={selected.length} />
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size='small'
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              order={order}
              orderBy={orderBy}
              rowCount={data.results.standing.length}
              contest={data.results.contest[0].nproblems}
            />
            <TableBody>
              {console.log(page)}
              {console.log(rowsPerPage)}
              {stableSort(finalFinalDat2, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.name);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  

                  if(row.partition)
                  {
                    return(
                      <h2>&nbsp;&nbsp;&nbsp;Practice</h2>
                    )
                  }
                  else
                  {
                    return (
                      <TableRow hover
                        tabIndex={-1}
                        key={row.name}
                      >
                        {console.log(officialNo)}
                        {(page*rowsPerPage) + index > officialNo ? <TableCell className={classes.tableCell} align="left">{((page*rowsPerPage) + index) - officialNo}</TableCell>:
                        <TableCell className={classes.tableCell} align="left">{(page*rowsPerPage) + index+1}</TableCell>}
                        <TableCell className={classes.tableCell} component="th" id={labelId} scope="row" padding="none" style={{fontSize:'1.1rem',fontWeight:'700'}}>
                          {row.user.rank === "newbie" ? <span style={{color:'gray'}}>{row.user.handle}</span>:
                            row.user.rank === "pupil" ? <span style={{color:'green'}}>{row.user.handle}</span>:
                            row.user.rank === "specialist" ? <span style={{color:'cyan'}}>{row.user.handle}</span>:
                            row.user.rank === "expert" ? <span style={{color:'blue'}}>{row.user.handle}</span>:
                            row.user.rank === "candidate master"  ? <span style={{color:'violet'}}>{row.user.handle}</span>:
                            row.user.rank === "international master" || row.user.rank === "master"? <span style={{color:'orange'}}>{row.user.handle}</span>:
                            row.user.rank === "grandmaster" || row.user.rank === "international grandmaster" ? <span style={{color:'red'}}>{row.user.handle}</span>:
                            <span style={{color:'black'}}>{row.user.handle}</span>
                          }
                        </TableCell>
                        <TableCell className={classes.tableCell} align="center">{getScore(row.submissions)}</TableCell>
                        <TableCell className={classes.tableCell} align="center">{row.submissions[0].penalty+row.submissions[1].penalty+row.submissions[2].penalty+row.submissions[3].penalty+row.submissions[4].penalty}</TableCell>
                        {row.submissions.map((subm,index) => {
                          return(
                            <TableCell className={classes.tableCell} align="left">
                          {row.submissions[index].isSolved ? <><DoneIcon/> <br/> - {row.submissions[index].penalty}</>:<><span>--</span></>}
                        </TableCell>
                          )
                        })}
                      </TableRow>
                    );
                  }
                })}
              {emptyRows > 0 && (
                <TableRow hover style={{ height: (dense ? 33 : 53) * emptyRows }}>
                  <TableCell className={classes.tableCell} colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {finalFinalDat2.length > 0 ? <TablePagination
          rowsPerPageOptions={[50, 75, 100]}
          component="div"
          count={finalFinalDat2.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />:<></>}
      </Paper>
    </div></>
  );
  }
}